import React, { useState, useCallback } from "react";
import "./Editor.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
];

//TODO: Add mention module after endpoint is fixed
const modulesWithToolbar = { toolbar: toolbarOptions };
const modulesWithoutToolbar = { toolbar: false };

const getInitialValue = (description, jsonDescription) => {
  if (jsonDescription !== null && jsonDescription !== "") {
    try {
      const parsedJson = JSON.parse(jsonDescription);
      return parsedJson;
    } catch (e) {
      return description || "";
    }
  } else {
    return description || "";
  }
};

const Editor = ({
  description,
  jsonDescription,
  editable,
  onDescriptionChange,
}) => {
  const [value, setValue] = useState(
    getInitialValue(description, jsonDescription)
  );
  const [toolbarVisible, setToolbarVisible] = useState(false);

  const handleChange = useCallback(
    (content, delta, source, editor) => {
      setValue(content);
      const plainText = editor.getText().trim();
      const jsonValue = JSON.stringify(editor.getContents());
      onDescriptionChange(jsonValue, plainText);
    },
    [onDescriptionChange]
  );

  return (
    <div className={!editable ? "disable_editor" : "quillEditor"}>
      {editable && (
        <button
          type="button"
          tabIndex="-1"
          className="editor-toolbar-toggle"
          title={toolbarVisible ? "Hide formatting" : "Show formatting"}
          onClick={() => setToolbarVisible((v) => !v)}
        >
          {toolbarVisible ? "▲ Hide formatting" : "▼ Formatting"}
        </button>
      )}
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        readOnly={!editable}
        placeholder="Enter description..."
        modules={toolbarVisible ? modulesWithToolbar : modulesWithoutToolbar}
      />
    </div>
  );
};
export default Editor;
